// import { Link } from "react-router-dom";
// import { useState } from "react";
// import { useCart } from "../context/CartContext";

// const Checkout = () => {
//   const { cartItems, cartTotal } = useCart();

//   const [formData, setFormData] = useState({
//     name: "",
//     phone: "",
//     email: "",
//     address: "",
//     city: "",
//   });

//   const [isPaying, setIsPaying] = useState(false);

//   const handleChange = (e) => {
//     setFormData({
//       ...formData,
//       [e.target.name]: e.target.value,
//     });
//   };

//   const formatPrice = (price) => {
//     return `TZS ${Number(price || 0).toLocaleString()}`;
//   };

//   const payWithFlutterwave = async (e) => {
//     e.preventDefault();

//     if (isPaying) return;

//     try {
//       setIsPaying(true);

//       const paymentData = {
//         tx_ref: `AFYA-${Date.now()}`,

//         amount: cartTotal,

//         name: formData.name,

//         phone: formData.phone,

//         email: formData.email,

//         address: formData.address,

//         city: formData.city,

//         items: cartItems.map((item) => ({
//           id: item.id,
//           name: item.name,
//           price: Number(item.price),
//           quantity: Number(item.quantity),
//         })),
//       };

//       const response = await fetch(
//         "https://afyaequip-payment-worker.leokadiafidelis031.workers.dev",
//         {
//           method: "POST",

//           headers: {
//             "Content-Type": "application/json",
//           },

//           body: JSON.stringify(paymentData),
//         }
//       );

//       const result = await response.json();

//       console.log("Flutterwave response:", result);

//       if (result.status === "success" && result.data?.link) {
//         window.location.href = result.data.link;
//         return;
//       }

//       alert(
//         result.message ||
//           "Unable to start payment. Please try again."
//       );

//       setIsPaying(false);
//     } catch (error) {
//       console.error("Payment error:", error);

//       alert(
//         "Something went wrong while starting payment."
//       );

//       setIsPaying(false);
//     }
//   };

//   if (cartItems.length === 0) {
//     return (
//       <main
//         className="
//           min-h-screen
//           bg-gray-50
//           flex
//           items-center
//           justify-center
//           px-6
//         "
//       >
//         <div
//           className="
//             bg-white
//             rounded-3xl
//             p-10
//             text-center
//             border
//             border-gray-200
//             shadow-sm
//           "
//         >
//           <h1 className="text-2xl font-bold text-gray-900">
//             Your Cart is Empty
//           </h1>

//           <p className="mt-3 text-gray-600">
//             Please add products before checkout.
//           </p>

//           <Link
//             to="/shop"
//             className="
//               inline-block
//               mt-6
//               bg-green-600
//               text-white
//               px-8
//               py-3
//               rounded-xl
//               font-semibold
//               hover:bg-green-700
//               transition
//             "
//           >
//             Browse Products
//           </Link>
//         </div>
//       </main>
//     );
//   }

//   return (
//     <main
//       className="
//         min-h-screen
//         bg-gray-50
//         py-12
//       "
//     >
//       <div
//         className="
//           max-w-7xl
//           mx-auto
//           px-6
//         "
//       >
//         <h1
//           className="
//             text-3xl
//             font-bold
//             text-gray-900
//             mb-8
//           "
//         >
//           Checkout
//         </h1>

//         <form
//           onSubmit={payWithFlutterwave}
//           className="
//             grid
//             lg:grid-cols-3
//             gap-8
//           "
//         >
//           {/* DELIVERY INFORMATION */}

//           <div
//             className="
//               lg:col-span-2
//               bg-white
//               rounded-2xl
//               border
//               border-gray-200
//               p-6
//             "
//           >
//             <h2 className="text-xl font-bold mb-6">
//               Delivery Information
//             </h2>

//             <div
//               className="
//                 grid
//                 md:grid-cols-2
//                 gap-5
//               "
//             >
//               <input
//                 name="name"
//                 placeholder="Full Name"
//                 value={formData.name}
//                 onChange={handleChange}
//                 required
//                 className="input"
//               />

//               <input
//                 name="phone"
//                 type="tel"
//                 placeholder="Phone Number"
//                 value={formData.phone}
//                 onChange={handleChange}
//                 required
//                 className="input"
//               />

//               <input
//                 name="email"
//                 type="email"
//                 placeholder="Email (optional)"
//                 value={formData.email}
//                 onChange={handleChange}
//                 className="input"
//               />

//               <input
//                 name="city"
//                 placeholder="City / Region"
//                 value={formData.city}
//                 onChange={handleChange}
//                 required
//                 className="input"
//               />

//               <textarea
//                 name="address"
//                 placeholder="Delivery Address"
//                 value={formData.address}
//                 onChange={handleChange}
//                 required
//                 rows="4"
//                 className="
//                   input
//                   md:col-span-2
//                 "
//               />
//             </div>
//           </div>

//           {/* ORDER SUMMARY */}

//           <div
//             className="
//               bg-white
//               rounded-2xl
//               border
//               border-gray-200
//               p-6
//               h-fit
//             "
//           >
//             <h2 className="text-xl font-bold mb-6">
//               Your Order
//             </h2>

//             <div className="space-y-4">
//               {cartItems.map((item) => (
//                 <div
//                   key={item.id}
//                   className="
//                     flex
//                     justify-between
//                     text-sm
//                     gap-4
//                   "
//                 >
//                   <span>
//                     {item.name}
//                     <br />
//                     x {item.quantity}
//                   </span>

//                   <span className="font-semibold">
//                     {formatPrice(
//                       Number(item.price) *
//                         Number(item.quantity)
//                     )}
//                   </span>
//                 </div>
//               ))}
//             </div>

//             <div
//               className="
//                 border-t
//                 mt-6
//                 pt-5
//                 flex
//                 justify-between
//               "
//             >
//               <span>Total</span>

//               <span
//                 className="
//                   font-bold
//                   text-green-600
//                   text-xl
//                 "
//               >
//                 {formatPrice(cartTotal)}
//               </span>
//             </div>

//             <button
//               type="submit"
//               disabled={isPaying}
//               className="
//                 w-full
//                 mt-8
//                 bg-green-600
//                 text-white
//                 py-3
//                 rounded-xl
//                 font-semibold
//                 hover:bg-green-700
//                 transition
//                 disabled:opacity-60
//                 disabled:cursor-not-allowed
//               "
//             >
//               {isPaying
//                 ? "Connecting to Payment..."
//                 : "Pay Now"}
//             </button>

//             <Link
//               to="/cart"
//               className="
//                 block
//                 text-center
//                 mt-4
//                 text-green-600
//               "
//             >
//               Back To Cart
//             </Link>
//           </div>
//         </form>
//       </div>
//     </main>
//   );
// };

// export default Checkout;

import { Link } from "react-router-dom";
import { useState } from "react";
import { Mail, CheckCircle } from "lucide-react";
import { useCart } from "../context/CartContext";

const Checkout = () => {
  const { cartItems, cartTotal } = useCart();

  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    address: "",
    city: "",
  });

  const [isPaying, setIsPaying] = useState(false);
  const [isSendingInvoice, setIsSendingInvoice] = useState(false);
  const [invoiceSent, setInvoiceSent] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const formatPrice = (price) => {
    return `TZS ${Number(price || 0).toLocaleString()}`;
  };

  // ==========================================
  // SEND INVOICE TO CUSTOMER EMAIL
  // ==========================================

  const sendInvoice = async () => {
    // Check required customer information
    if (!formData.name.trim()) {
      alert("Please enter your full name.");
      return;
    }

    if (!formData.email.trim()) {
      alert("Please enter your email address to receive the invoice.");
      return;
    }

    if (!formData.phone.trim()) {
      alert("Please enter your phone number.");
      return;
    }

    if (!formData.city.trim()) {
      alert("Please enter your city / region.");
      return;
    }

    if (!formData.address.trim()) {
      alert("Please enter your delivery address.");
      return;
    }

    if (isSendingInvoice) return;

    try {
      setIsSendingInvoice(true);
      setInvoiceSent(false);

      const invoiceData = {
        name: formData.name,
        email: formData.email,
        phone: formData.phone,
        address: formData.address,
        city: formData.city,

        items: cartItems.map((item) => ({
          id: item.id,
          name: item.name,
          price: Number(item.price),
          quantity: Number(item.quantity),
        })),

        total: Number(cartTotal),
      };

      const response = await fetch(
        "https://afyaequip-payment-worker.leokadiafidelis031.workers.dev/send-invoice",
        {
          method: "POST",

          headers: {
            "Content-Type": "application/json",
          },

          body: JSON.stringify(invoiceData),
        },
      );

      const result = await response.json();

      console.log("Invoice response:", result);

      if (result.status === "success") {
        setInvoiceSent(true);

        // Remove success message after 5 seconds
        setTimeout(() => {
          setInvoiceSent(false);
        }, 5000);

        return;
      }

      alert(result.message || "Unable to send invoice. Please try again.");
    } catch (error) {
      console.error("Invoice error:", error);

      alert("Something went wrong while sending the invoice.");
    } finally {
      setIsSendingInvoice(false);
    }
  };

  // ==========================================
  // PESAPAL PAYMENT
  // ==========================================

  const payWithPesapal = async (e) => {
    e.preventDefault();

    if (isPaying) return;

    // Validate checkout information
    if (!formData.name.trim()) {
      alert("Please enter your full name.");
      return;
    }

    if (!formData.phone.trim()) {
      alert("Please enter your phone number.");
      return;
    }

    if (!formData.email.trim()) {
      alert("Please enter your email address.");
      return;
    }

    if (!formData.city.trim()) {
      alert("Please enter your city / region.");
      return;
    }

    if (!formData.address.trim()) {
      alert("Please enter your delivery address.");
      return;
    }

    try {
      setIsPaying(true);

      const paymentData = {
        amount: Number(cartTotal),

        reference: `AFYA-${Date.now()}`,

        description: "AfyaEquip Order",

        customer_name: formData.name,

        customer_email: formData.email,

        customer_phone: formData.phone,

        address: formData.address,

        city: formData.city,

        items: cartItems.map((item) => ({
          id: item.id,
          name: item.name,
          price: Number(item.price),
          quantity: Number(item.quantity),
        })),
      };

      console.log("Sending Pesapal payment:", paymentData);

      const response = await fetch(
        "https://afyaequip-payment-worker.leokadiafidelis031.workers.dev/create-payment",
        {
          method: "POST",

          headers: {
            "Content-Type": "application/json",
          },

          body: JSON.stringify(paymentData),
        },
      );

      const result = await response.json();

      console.log("Pesapal response:", result);

      if (result.success && result.redirect_url) {
        // Save tracking information for later verification
        sessionStorage.setItem("pesapal_tracking_id", result.order_tracking_id);

        sessionStorage.setItem("pesapal_reference", result.merchant_reference);

        // Send customer to Pesapal payment page
        window.location.href = result.redirect_url;

        return;
      }

      alert(
        result.message || "Unable to start Pesapal payment. Please try again.",
      );

      setIsPaying(false);
    } catch (error) {
      console.error("Pesapal payment error:", error);

      alert("Something went wrong while starting the payment.");

      setIsPaying(false);
    }
  };

  // ==========================================
  // EMPTY CART
  // ==========================================

  if (cartItems.length === 0) {
    return (
      <main className="min-h-screen bg-gray-50 py-20">
        <div className="max-w-3xl mx-auto text-center px-6">
          <h1 className="text-3xl font-bold text-gray-900">
            Your Cart is Empty
          </h1>

          <p className="mt-3 text-gray-600">
            Please add products before checkout.
          </p>

          <Link
            to="/shop"
            className="
              inline-block
              mt-6
              bg-green-600
              text-white
              px-8
              py-3
              rounded-xl
              font-semibold
              hover:bg-green-700
              transition
            "
          >
            Browse Products
          </Link>
        </div>
      </main>
    );
  }

  return (
    <main className="min-h-screen bg-gray-50 py-12">
      <div className="max-w-6xl mx-auto px-6">
        {/* PAGE TITLE */}

        <h1 className="text-3xl font-bold text-gray-900 mb-8">Checkout</h1>

        <form
          onSubmit={payWithPesapal}
          className="grid lg:grid-cols-3 gap-8"
        >
          {/* =====================================
              DELIVERY INFORMATION
          ====================================== */}

          <div
            className="
              lg:col-span-2
              bg-white
              rounded-2xl
              border
              border-gray-200
              p-6
            "
          >
            <h2 className="text-xl font-bold mb-6">Delivery Information</h2>

            <div
              className="
                grid
                md:grid-cols-2
                gap-5
              "
            >
              {/* FULL NAME */}

              <input
                name="name"
                placeholder="Full Name"
                value={formData.name}
                onChange={handleChange}
                required
                className="input"
              />

              {/* PHONE */}

              <input
                name="phone"
                type="tel"
                placeholder="Phone Number"
                value={formData.phone}
                onChange={handleChange}
                required
                className="input"
              />

              {/* EMAIL */}

              <div className="md:col-span-2">
                <input
                  name="email"
                  type="email"
                  placeholder="Email Address"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="input w-full"
                />

                <p className="text-xs text-gray-500 mt-2">
                  Your invoice and order information will be sent to this email.
                </p>
              </div>

              {/* CITY */}

              <input
                name="city"
                placeholder="City / Region"
                value={formData.city}
                onChange={handleChange}
                required
                className="input"
              />

              {/* ADDRESS */}

              <textarea
                name="address"
                placeholder="Delivery Address"
                value={formData.address}
                onChange={handleChange}
                required
                rows="4"
                className="
                  input
                  md:col-span-2
                "
              />
            </div>
          </div>

          {/* =====================================
              ORDER SUMMARY
          ====================================== */}

          <div
            className="
              bg-white
              rounded-2xl
              border
              border-gray-200
              p-6
              h-fit
            "
          >
            <h2 className="text-xl font-bold mb-6">Your Order</h2>

            {/* ITEMS */}

            <div className="space-y-4">
              {cartItems.map((item) => (
                <div
                  key={item.id}
                  className="
                    flex
                    justify-between
                    text-sm
                    gap-4
                  "
                >
                  <span>
                    {item.name}
                    <br />
                    <span className="text-gray-500">x {item.quantity}</span>
                  </span>

                  <span className="font-semibold">
                    {formatPrice(Number(item.price) * Number(item.quantity))}
                  </span>
                </div>
              ))}
            </div>

            {/* TOTAL */}

            <div
              className="
                border-t
                mt-6
                pt-5
                flex
                justify-between
              "
            >
              <span className="font-medium">Total</span>

              <span
                className="
                  font-bold
                  text-green-600
                  text-xl
                "
              >
                {formatPrice(cartTotal)}
              </span>
            </div>

            {/* =====================================
                INVOICE SUCCESS MESSAGE
            ====================================== */}

            {invoiceSent && (
              <div
                className="
                  mt-5
                  flex
                  items-start
                  gap-3
                  bg-green-50
                  border
                  border-green-200
                  rounded-xl
                  p-4
                "
              >
                <CheckCircle size={22} className="text-green-600 mt-0.5" />

                <div>
                  <p className="font-semibold text-green-800">Invoice sent!</p>

                  <p className="text-sm text-green-700 mt-1">
                    Please check your email for the invoice.
                  </p>
                </div>
              </div>
            )}

            {/* =====================================
                EMAIL INVOICE BUTTON
            ====================================== */}

            <button
              type="button"
              onClick={sendInvoice}
              disabled={isSendingInvoice || isPaying}
              className="
                w-full
                mt-8
                flex
                items-center
                justify-center
                gap-2
                border
                border-green-600
                text-green-600
                py-3
                rounded-xl
                font-semibold
                hover:bg-green-50
                transition
                disabled:opacity-60
                disabled:cursor-not-allowed
              "
            >
              <Mail size={19} />

              {isSendingInvoice
                ? "Sending Invoice..."
                : "Email Me This Invoice"}
            </button>

            {/* =====================================
                PAYMENT BUTTON
            ====================================== */}

            <button
              type="submit"
              disabled={isPaying || isSendingInvoice}
              className="
                w-full
                mt-3
                bg-green-600
                text-white
                py-3
                rounded-xl
                font-semibold
                hover:bg-green-700
                transition
                disabled:opacity-60
                disabled:cursor-not-allowed
              "
            >
              {isPaying ? "Connecting to Payment..." : "Pay Now"}
            </button>

            {/* BACK TO CART */}

            <Link
              to="/cart"
              className="
                block
                text-center
                mt-4
                text-green-600
                hover:text-green-700
                text-sm
              "
            >
              Back To Cart
            </Link>
          </div>
        </form>
      </div>
    </main>
  );
};

export default Checkout;
